var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player"},[_c('iframe',{attrs:{"src":_vm.url,"width":_vm.width,"height":_vm.height,"frameborder":"0","allow":"autoplay; fullscreen; picture-in-picture","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }